"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Function to get icon for message
 * @function getMessageIconName
 * @param { string }  - returns icon based on message type or user passed iconName
 */

const getMessageIcon = (iconName, messageType, iconSize) => {
  const getIconName = () => {
    if (iconName) {
      return iconName;
    }
    switch (messageType) {
      case 'error':
        return 'exclamationTriangle';
      case 'warning':
        return 'exclamationTriangle';
      case 'success':
        return 'check';
      case 'info':
      default:
        return 'infoCircle';
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: getIconName(),
    size: iconSize
  });
};
exports.getMessageIcon = getMessageIcon;